/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type FieldsetProps = {
  children: React.ReactNode;
};

const StyledFieldset = styled.fieldset<FieldsetProps>`
  margin: 0 0 ${theme.spacing.spacing04} 0;
`;

function Fieldset(props: FieldsetProps) {
  return <StyledFieldset {...props}>{props.children}</StyledFieldset>;
}

export default Fieldset;
